"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCESS_TOKEN_COOKIE_NAME = exports.NEWSLETTER_FINISH_WO_INSIGHTS = exports.AMPLITUDE_IDENTIFY_TAGS = exports.FREEMIUM = exports.PLACEHOLDER_TEXTS = exports.DATA_ANALYTICS_TAG = exports.EMARKETER_DAILY_TEXT = exports.INDUSTRIES = exports.EXCLUDED_DOMAINS = exports.HEADER_TEXTS = exports.LENGTH_VALIDATION = exports.EMAIL_DISCLAIMER = exports.INVALID_INDUSTRY_ERROR = exports.PASSWORD_RESERVED_WORD_ERROR = exports.PASSWORD_AT_LEAST_ONE_LETTER_AND_NUMBER_ERROR = exports.PASSWORD_LENGTH_ERROR = exports.VERIFICATION_CODE_DAILY_LIMIT_ERROR_CODE = exports.VERIFICATION_CODE_LOCKED_ERROR_CODE = exports.RESEND_CODE_COOLDOWN_SECONDS = exports.RESEND_CODE_SUCCESS_MESSAGE = exports.INVALID_CODE_ERROR = exports.COMPANY_NAME_LENGTH_ERROR = exports.COMPANY_NAME_EMPTY_ERROR = exports.JOB_TITLE_LENGTH_ERROR = exports.JOB_TITLE_EMPTY_ERROR = exports.COMPANY_NAME_REQUIRED_ERROR = exports.LAST_NAME_REQUIRED_ERROR = exports.FIRST_NAME_REQUIRED_ERROR = exports.EMAIL_BUSINESS_EMAIL_ERROR = exports.EMAIL_VALIDATION_ERROR = exports.EMAIL_REQUIRED_ERROR = exports.SOMETHING_WENT_WRONG_ERROR = void 0;
const TaxonomyType_1 = require("@/types/TaxonomyType");
const react_1 = __importDefault(require("react"));
exports.SOMETHING_WENT_WRONG_ERROR = 'Something went wrong. Please try again later.';
exports.EMAIL_REQUIRED_ERROR = 'Please enter a email address.';
exports.EMAIL_VALIDATION_ERROR = 'Please enter a valid email address.';
exports.EMAIL_BUSINESS_EMAIL_ERROR = 'Please enter a valid business email.';
exports.FIRST_NAME_REQUIRED_ERROR = 'Please enter a first name.';
exports.LAST_NAME_REQUIRED_ERROR = 'Please enter a last name.';
exports.COMPANY_NAME_REQUIRED_ERROR = 'Please enter a company name.';
exports.JOB_TITLE_EMPTY_ERROR = 'Job title cannot be empty or whitespace.';
exports.JOB_TITLE_LENGTH_ERROR = 'Job title must be between 3 and 128 characters.';
exports.COMPANY_NAME_EMPTY_ERROR = 'Company Name cannot be empty or whitespace.';
exports.COMPANY_NAME_LENGTH_ERROR = 'Company Name must not exceed 255 characters.';
exports.INVALID_CODE_ERROR = 'Please enter the code sent to your email.';
// Each resend invalidates the previous code. The copy is the same whether or not an email was actually sent,
// so it never reveals whether the address is already registered.
exports.RESEND_CODE_SUCCESS_MESSAGE = 'New code sent. Use the code from the most recent email.';
// How long "Click to resend" stays disabled: from when the code step opens (a code was just emailed) and after
// each successful resend.
//
// PARITY - keep this identical to the server-side value; if you change one, change both in the same release:
//  - here (UI only; it does not protect anything on its own)
//  - eMarketer.TotalAccess.Subscriptions: Constants.VerificationCodeResendCooldownSeconds in
//    Web/Infrastructure/Constants.cs, which makes /ResendVerificationCode issue no new code while the newest code is
//    younger than this
// If this value is shorter than the server's, users can click resend, see "New code sent" and receive nothing,
// because the server silently refuses the request (it cannot say why without revealing whether the email is
// registered). If it is longer, users wait more than they need to.
exports.RESEND_CODE_COOLDOWN_SECONDS = 60;
// ErrorCode the API returns (with Field "code") once a verification code has used up its attempts.
exports.VERIFICATION_CODE_LOCKED_ERROR_CODE = 'VerificationCodeLocked';
// ErrorCode the API returns (with Field "code") once the email has used its daily allowance of guesses across all
// its codes (15 a day, VerificationCodeMaxAttemptsPerDay in eMarketer.TotalAccess.Subscriptions). The UI only
// reacts to this code, not to the number, so the allowance can change on the server alone.
exports.VERIFICATION_CODE_DAILY_LIMIT_ERROR_CODE = 'VerificationCodeDailyLimit';
exports.PASSWORD_LENGTH_ERROR = 'Must be 7-14 characters and include numbers and letters';
exports.PASSWORD_AT_LEAST_ONE_LETTER_AND_NUMBER_ERROR = 'Must contain at least one letter and one number';
exports.PASSWORD_RESERVED_WORD_ERROR = 'Password contains a word that is not allowed';
exports.INVALID_INDUSTRY_ERROR = 'Please select an industry';
exports.EMAIL_DISCLAIMER = 'By entering your email, you agree to receive marketing emails from EMARKETER.';
exports.LENGTH_VALIDATION = {
    FIRST_NAME: 40,
    LAST_NAME: 80,
    COMPANY_NAME: 255,
    JOB_TITLE: 128,
};
exports.HEADER_TEXTS = {
    EMAIL_REGISTRATION: {
        TITLE: 'Create your free account to continue reading.',
        /**
         * Returns the subtitle for the email registration step.
         * @param plgThresholdToShowPopup The threshold to show the popup.
         * @returns The subtitle string.
         */
        subtitle: (plgThresholdToShowPopup) => {
            const value = /^\d+$/.test(plgThresholdToShowPopup) && Number(plgThresholdToShowPopup) > 0
                ? Number(plgThresholdToShowPopup) - 1 // subtract 1 to account for the current article
                : 'allowed';
            return `You’ve reached your limit of ${value} free articles this month. Unlock this article and get access to more curated insights with an account.`;
        },
    },
    CODE_AND_PASSWORD: {
        TITLE: 'Check your email',
        SUBTITLE: (email) => {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                "We\u2019ve sent you a six-digit confirmation code to ",
                react_1.default.createElement("strong", null, email),
                ". Please enter it below to confirm your email address and create a password."));
        },
    },
    DEMOGRAPHICS: {
        TITLE: 'Let’s get you set up, it will take you less than one minute!',
        SUBTITLE: 'Help us personalize your EMARKETER experience by telling us about yourself.',
    },
    INDUSTRIES: {
        TITLE: 'Get the insights that matter to you.',
        SUBTITLE: 'Select the topics you are interested in (select all that apply)',
    },
    NEWSLETTERS: {
        TITLE: 'Get insights straight to the top of your inbox.',
        SUBTITLE: 'Select which newsletters you’d like to begin receiving (select all that apply)',
    },
    SUCCESS: {
        TITLE: 'Your free account is all set.',
        SUBTITLE: '',
    },
};
exports.EXCLUDED_DOMAINS = [
    '@126.com',
    '@163.com',
    '@abv.bg',
    '@allfreemail.net',
    '@aol.com',
    '@aol.de',
    '@arcor.de',
    '@att.net',
    '@bell.net',
    '@bellsouth.net',
    '@bigpond.net.au',
    '@bluewin.ch',
    '@btconnect.co.uk',
    '@btconnect.com',
    '@btinternet.com',
    '@comcast.net',
    '@cox.net',
    '@earthlink.net',
    '@email.com',
    '@email.cz',
    '@foxmail.com',
    '@gmail.com',
    '@gmail.org',
    '@gmx.com',
    '@gmx.de',
    '@gmx.fr',
    '@gmx.us',
    '@go2.pl',
    '@googlemail.com',
    '@hanmail.net',
    '@hotmail.be',
    '@hotmail.co.uk',
    '@hotmail.com',
    '@hotmail.com.sa',
    '@hotmail.fr',
    '@hotmail.it',
    '@icloud.com',
    '@icloud.net',
    '@Info.com',
    '@interia.pl',
    '@ix.netcom.com',
    '@libero.it',
    '@live.co.uk',
    '@live.co.za',
    '@live.com',
    '@live.no',
    '@mac.com',
    '@mail.com',
    '@mail.ru',
    '@mailinator.com',
    '@me.com',
    '@mindspring.com',
    '@msn.com',
    '@naver.com',
    '@netscape.net',
    '@netzero.net',
    '@new.rr.com',
    '@nyc.rr.com',
    '@onet.pl',
    '@optonline.net',
    '@orange.fr',
    '@outlook.com',
    '@outlook.my',
    '@pobox.com',
    '@pro.onet.pl',
    '@prodigy.net',
    '@prodigy.net.mx',
    '@qq.com',
    '@rediffmail.com',
    '@rocketmail.com',
    '@sbcglobal.net',
    '@seznam.cz',
    '@sprintmail.com',
    '@suddenlink.net',
    '@sudomail.com',
    '@test.com',
    '@triad.rr.com',
    '@tutanota.com',
    '@uol.com.br',
    '@verizon.net',
    '@vip.126.com',
    '@web.de',
    '@webmail.co.za',
    '@ya.ru',
    '@yahoo.co.id',
    '@yahoo.co.in',
    '@yahoo.co.uk',
    '@yahoo.com',
    '@yahoo.com.ar',
    '@yahoo.com.hk',
    '@yahoo.com.sg',
    '@yahoo.es',
    '@yahoo.fr',
    '@yahoo.gr',
    '@yahoo.it',
    '@yandex.com',
    '@yandex.ru',
    '@ymail.com',
    '@zohomail.eu',
    '@live.com.my',
    '@telefonica.net',
    '@o2.pl',
    '@sky.com',
    '@yahoo.com.br',
    '@gmx.net',
    '@duck.com',
    '@live.fr',
    '@mozmail.com',
    '@execs.com',
    '@sapo.pt',
    '@maine.rr.com',
    '@yahoo.de',
    '@gmail.com.fr',
    '@simplelogin.com',
    '@gufum.com',
    '@libero.it',
    '@muell.io',
    '@burnermail.io',
    '@zohomail.in',
    '@zmailpro.com',
    '@yahoo.com.my',
    '@outlook.be',
];
exports.INDUSTRIES = [
    [
        {
            label: 'Advertising',
            analyticsSuffix: 'Advertising',
            taxonomyType: TaxonomyType_1.TaxonomyType.Topic,
        },
        {
            label: 'Financial Services',
            analyticsSuffix: 'FinancialServices',
            taxonomyType: TaxonomyType_1.TaxonomyType.Industry,
        },
        {
            label: 'Marketing',
            analyticsSuffix: 'Marketing',
            taxonomyType: TaxonomyType_1.TaxonomyType.Topic,
        },
    ],
    [
        {
            label: 'Ecommerce',
            analyticsSuffix: 'Ecommerce',
            taxonomyType: TaxonomyType_1.TaxonomyType.Industry,
        },
        {
            label: 'Health',
            analyticsSuffix: 'Health',
            taxonomyType: TaxonomyType_1.TaxonomyType.Industry,
        },
        {
            label: 'Technology',
            analyticsSuffix: 'Technology',
            taxonomyType: TaxonomyType_1.TaxonomyType.Industry,
        },
    ],
];
exports.EMARKETER_DAILY_TEXT = 'EMARKETER Daily';
exports.DATA_ANALYTICS_TAG = {
    EMAIL_REGISTRATION: {
        CONTINUE: (prefix) => `${prefix}-UserOnboarding-BusinessEmail-Continue`,
        SIGN_IN: (prefix) => `${prefix}-UserOnboarding-BusinessEmail-SignIn`,
        REDIRECT: (prefix) => `${prefix}-UserOnboarding-BusinessEmailRedirect`, // user is redirected OUT OF the Freemium Onboarding (becasue email validation did not pass)
        CAPTCHA_ERROR: (prefix) => `${prefix}-UserOnboarding-BusinessEmailCaptchaError`, // user is redirected OUT OF the Freemium Onboarding (becasue email validation did not pass)
    },
    CODE_AND_PASSWORD: {
        CREATE_ACCOUNT: (prefix) => `${prefix}-UserOnboarding-CreateAccount`,
        RESEND: (prefix) => `${prefix}-UserOnboarding-Resendcode`,
    },
    DEMOGRAPHICS: {
        NEXT: (prefix) => `${prefix}-UserOnboarding-Demographics`,
    },
    INDUSTRIES: {
        NEXT: (prefix) => `${prefix}-UserOnboarding-Industry-Next`,
        BACK: (prefix) => `${prefix}-UserOnboarding-Industry-Back`,
        INDUSTRY_SELECTION: (prefix, industry) => `${prefix}-UserOnboarding-IndustrySelection-${industry}`,
    },
    NEWSLETTERS: {
        NEXT: (prefix) => `${prefix}-UserOnboarding-NewsLetters-Next`,
        BACK: (prefix) => `${prefix}-UserOnboarding-NewsLetters-Back`,
        SKIP: (prefix) => `${prefix}-UserOnboarding-NewsLetters-Skip`,
        NEWSLETTER_SELECTION: (prefix, newsletter) => `${prefix}-UserOnboarding-NewsletterSelection-${newsletter}`,
    },
    SUCCESS: {
        CONTINUE: (prefix) => `${prefix}-UserOnboarding-ContinueReading`,
        EXPLORE_FREE_TRIALS: (prefix) => `${prefix}-UserOnboarding-ExploreFreeTrials`,
        INVITEACOLLEAGUE: (prefix) => `${prefix}-UserOnboarding-InviteAColleague`,
    },
    INVITE_A_COLLEAGUE: {
        ACCEPTED: (prefix) => `${prefix}-UserOnboarding-InviteAccepted`,
    },
};
exports.PLACEHOLDER_TEXTS = {
    EMAIL_REGISTRATION: {
        EMAIL: `Enter your business email`,
    },
    CODE_AND_PASSWORD: {
        CODE: `Enter code sent to your email`,
        PASSWORD: `Create a password`,
    },
    DEMOGRAPHICS: {
        FIRST_NAME: `First Name`,
        LAST_NAME: `Last Name`,
        COMPANY_NAME: `Company Name`,
        JOB_TITLE: `Job Title`,
        INDUSTRY: `Your Industry`,
    },
};
// Matches value set in TotalAccess.Subscription.Web
exports.FREEMIUM = {
    REMAINING_STEPS: {
        PASSWORD: '4',
        DEMOGRAPHICS: '3',
        INDUSTRIES: '2',
        NEWSLETTERS: '1',
        NONE: 0,
    },
    COOKIE_NAME: 'em_fosr',
    COOKIE_EXPIRY: 36500,
    COOKIE_DOMAIN: '.emarketer.com',
};
const AMPLITUDE_IDENTIFY_TAGS_PREFIX = 'em-fo';
exports.AMPLITUDE_IDENTIFY_TAGS = {
    FORM: `${AMPLITUDE_IDENTIFY_TAGS_PREFIX}-frm`,
    TEXTBOX: `${AMPLITUDE_IDENTIFY_TAGS_PREFIX}-txt`,
    SELECT: `${AMPLITUDE_IDENTIFY_TAGS_PREFIX}-sel`,
    BUTTON: `${AMPLITUDE_IDENTIFY_TAGS_PREFIX}-btn`,
    ATAG: `${AMPLITUDE_IDENTIFY_TAGS_PREFIX}-atag`,
    CHECKBOX: `${AMPLITUDE_IDENTIFY_TAGS_PREFIX}-cbx`,
};
exports.NEWSLETTER_FINISH_WO_INSIGHTS = 'Finish without email insights';
exports.ACCESS_TOKEN_COOKIE_NAME = 'em_at';
